import React,{Component} from 'react';
import { officeSetupSteps, OFFICE_FUNCTIONS, OFFICE_END_PRODUCT, OFFICE_END_CUSTOMER } from '../../../utils/constants';
import Steps from '../../../components/Steps/Steps';
import {Input,Label,Button,Alert, Popover, PopoverHeader, PopoverBody,Col,Row} from 'reactstrap';
import Select from 'react-select';
import axios from '../../../axios';
import * as url from '../../../utils/url';
import { connect } from 'react-redux';
import PlacesAutocomplete, {
    geocodeByAddress,
    getLatLng,
  } from 'react-places-autocomplete';
import { validateOfficeSetupOfficeDetails } from '../../../utils/validations';
import './OfficeDetails.css';
import { classnames } from '../../../utils/place-autocomplete-helpers';
import * as actionCreators from '../../../modules/actions/index';
import rightArrow from './../../../assets/arrow-right.png';
import Tooltip from '../../../components/UI/TooltipIcon/TooptipIcon';
import sortBy from 'lodash/sortBy';
import { isMobile } from '../../../utils/deviceInfo';
import If from '../../../components/Shared/If';

class OfficeDetails extends Component {

    constructor(props) {
        super(props);
        this.state = {
            address : this.props.office.address ? this.props.office.address.fullAddress :  '',
            displayName: this.props.office.displayName ? this.props.office.displayName : '',
            formErrorFields : [],
            officeFunction : this.props.office.occupation ? this.props.office.occupation : null,
            productType : this.props.office.productType ? this.props.office.productType : null,
            customerType : this.props.office.customerType ? this.props.office.customerType : null,
            latitude: this.props.office.latitude ? parseFloat(this.props.office.latitude) : null,
            longitude: this.props.office.longitude ? parseFloat(this.props.office.longitude) : null,
            officeSizePopoverOpen: false,
            officeFunctions: [],
            productTypes: [],
            customerTypes: [],
        };
    }

  componentDidMount = () => {
    this.getOccupationCustomerProductList();
  }

  handleAddressChange = (address) => {
    this.setState({
        address : address, latitude: null, longitude: null
    })
  }

  getOccupationCustomerProductList = () => {
    axios.get(url.getOccupationCustomerProductList).then((response) => {
        // console.log(response.data);
        let officeFunctions = [], productTypes = [], customerTypes = [];
        for(let category of response.data.data) {
            if(category._id === 'PRODUCT'){
                productTypes = category.docs.map((doc) => {
                    return {_id: doc._id, name: doc.name}
                });
            } else if (category._id === 'CUSTOMER') {
                customerTypes = category.docs.map((doc) => {
                    return {_id: doc._id, name: doc.name}
                });
            } else if (category._id === 'OCCUPATION') {
                officeFunctions = category.docs.map((doc) => {
                    return {_id: doc._id, name: doc.name}
                });
            }
        }
        officeFunctions = sortBy(officeFunctions, ['name']);
        productTypes = sortBy(productTypes, ['name']);
        customerTypes = sortBy(customerTypes, ['name']);
        this.setState({officeFunctions, productTypes, customerTypes});
    }).catch((error) => {
        console.log(error);
    })
  }

  handleSelect = address => {
    this.setState({ address: address });
    geocodeByAddress(address)
      .then(results => {
        const result = results[0];
        getLatLng(results[0]).then((latLng) => {
            let state = '';
            for(let i = 0 ; i < result.address_components.length ; i++) {
                const address = result.address_components[i];
                // console.log(address);
                if(address.types.indexOf("administrative_area_level_1") > -1) {
                    state = address.long_name;
                }
            }
            this.setState({address: address,
                latitude: latLng.lat,
                longitude: latLng.lng,
                state : state
            });
        })
      })
      .catch(error => console.error('Error', error));
   };

  handleOptionOfficeFunction = (value) => {
    this.setState({
        officeFunction : value
    })
  }

  handleOptionEndCustomer = (value) => {
    this.setState({
        customerType : value
    })
  }

  handleOptionEndProduct = (value) => {
    this.setState({
        productType : value
    })
  }

  handleDisplayNameChange = ({target}) => {
    const {name,value} = target;
    this.setState({
        displayName : value
    });
 }

  handleContinue = () => {
    const {displayName,officeFunction,productType,customerType,address,latitude, longitude,state} = this.state;
    const errorFields = validateOfficeSetupOfficeDetails(this.state)
    if(errorFields.length > 0) {
        window.scroll(0,0);
      this.setState({
        formError : true,
        formErrorFields :errorFields
      })
      return;
    } else {
        this.setState({
          formError : false,
          formErrorFields : []
        })
      }
    const formData = new FormData();
    if (displayName) {
        formData.append("displayName", displayName);
    }
    if (officeFunction && officeFunction._id) {
        formData.append("occupation", officeFunction._id);
    }

    if (productType && productType._id) {
        formData.append("productType", productType._id);
    } else if(productType && !productType._id) {
        formData.append("productType", productType);
    }

    if (customerType && customerType._id) {
        formData.append("customerType", customerType._id);
    } else if(customerType && !customerType._id) {
        formData.append("customerType", customerType);
    }

    if(address) {
        formData.append("fullAddress",address);
    }
    if(latitude && latitude!==null) {
        formData.append("latitude",latitude);
    }
    if(longitude && longitude!==null) {
        formData.append("longitude",longitude);
    }
    if(state && state !== null) {
        formData.append("state",state);
    }
    formData.append("isOfficeConfigured",true);
    const {officeId} = this.props.user.profile;
    let id;
    if(Object.keys(officeId).length > 0) {
        id = officeId._id;
    } else {
        id = officeId;
    }
    axios.put(url.updateOffice(id),formData,{ headers: {
        'Content-Type': 'multipart/form-data'
      }}).then(({data}) => {
    //   console.log(data.data);
      this.props.onFetchOfficeSuccess(data.data);
      this.props.history.push('add-members');
    }).catch((error) => {
      //todo show error
    });
  }

  toggleOfficeSizePopover = () => {
    this.setState({
        officeSizePopoverOpen: !this.state.officeSizePopoverOpen
    });
  }

  render(){
    const {officeId} = this.props.user.profile;
    // console.log(this.state);
    const {officeFunction,customerType,productType,formError,formErrorFields,displayName,officeFunctions,productTypes,customerTypes} = this.state;
    return(
      <div className={`${isMobile && 'mt-3'} page-title-box`}>
        <If condition={!isMobile}>
          <div className="title-text">Office Details</div>
          <Steps
            steps={officeSetupSteps}
            currentStep={2}
          />
        </If>
        {
          formError ?
          <div className="alert-msg-bg mt50">
			<i className="close-icon">close</i>
			<div className="d-flex custom-message-box">
			  <i className="material-icons alert-icon-bg font18">remove_circle</i>
			  <span className="message-sub-text ml20">There were some errors with your form.
              Please fix the highlighted fields below.</span>
			</div>
		    </div> : null
        }
        <div className="row text-size">
            <div className={`${isMobile ? 'pl-4 mb-2':'textbox-lable'}`}>
                <Label for="officeName" className="field-lable">Office Name</Label>
            </div>
            <div className={`${isMobile && 'pl-4'} textbox-field `}>
                <Input type="text" name="officeName" className="input-custom"
                    value={officeId.name}
                    readOnly/>
            </div>
        </div>
        <div className="row text-size" style={{marginTop:20}}>
            <div className={`${isMobile ? 'pl-4 mb-2 d-inline-block':'textbox-lable'}`}>
                <Label for="displayName" className="field-lable">
                    Display Name
                </Label>
            </div>
            <If condition={isMobile}>
                <div className="row text-size">
                    <div className={`${isMobile ? 'pl-4 mb-2 d-inline-block':'textbox-lable'}`}>
                        <span style={{float:'right',marginTop:-13}} className="optional-text">(optional)</span>
                    </div>
                    <div className={`${isMobile && 'pl-4'} textbox-field `}>

                    </div>
                </div>
            </If>
            <div className={`${isMobile && 'pl-4'} textbox-field `}>
            <div className="inner-addon right-addon">
            <span className="name-hint-max-length name-char-count-txt">{displayName.length}/64</span>
                <Input type="text" className="text-size text-normalinputBox-height"
                name="officeDisplayName"
                onChange={this.handleDisplayNameChange}
                value={displayName}
                maxLength="64"
                placeholder="Provide display name for others to see, if not same as the above"/>
            </div>
            </div>
        </div>
        <If condition={!isMobile}>
        <div className="row text-size">
            <div className="textbox-lable">
                <span style={{float:'right',marginTop:-13}} className="optional-text">(optional)</span>
            </div>
            <div className={`${isMobile && 'pl-4'} textbox-field `}>

            </div>
        </div>
        </If>

        <div className="row text-size" style={{marginTop:20}}>
            <div className={`${isMobile ? 'pl-4 mb-2':'textbox-lable'}`}>
                <Label for="officeFunction" className="field-lable">Function</Label>
            </div>
            <div className={`${isMobile && 'pl-4'} select-field`}>
                    <Select name="officeFunction"
                        options={officeFunctions}
                        searchable={!isMobile}
                        value={officeFunction}
                        clearable={false}
                        style={formErrorFields.indexOf('officeFunction') > -1 ? { 'border': '1px solid #dc3545' } : {}}
                        onChange={this.handleOptionOfficeFunction}
                        placeholder="Select primary function of your office"
                        valueKey='_id'
                        labelKey='name'
                    />
                    {formError && (formErrorFields.indexOf('officeFunction') > -1) && <div className="input-error-msg-field">Please enter the main function of your office</div>}
            </div>
        </div>
        <div className="row text-size" style={{marginTop:20}}>
            <div className={`${isMobile ? 'pl-4 mb-2':'textbox-lable'}`}>
                <Label for="position" className="field-lable">Product Type</Label>
            </div>
            <If condition={isMobile}>
                <div className="row text-size">
                    <div className={`${isMobile ? 'pl-4 mb-2':'textbox-lable'}`}>
                        <span style={{float:'right',marginTop:-13}} className="optional-text">(optional)</span>
                    </div>
                    <div className={`${isMobile && 'pl-4'} textbox-field `}>
                    </div>
                </div>
            </If>
            <div className={`${isMobile && 'pl-4'}  select-field`}>
                    <Select name="officeEndProduct"
                        searchable={!isMobile}
                        placeholder={"Select primary type of product your office provides"}
                        options={productTypes}
                        value={productType}
                        onChange={this.handleOptionEndProduct}
                        valueKey='_id'
                        labelKey='name'
                    />
            </div>
        </div>
        <If condition={!isMobile}>
            <div className="row text-size">
                <div className="textbox-lable">
                    <span style={{float:'right',marginTop:-13}} className="optional-text">(optional)</span>
                </div>
                <div className={`${isMobile && 'pl-4'} textbox-field `}>
                </div>
            </div>
        </If>

        <div className="row text-size" style={{marginTop:20}}>
            <div className={`${isMobile ? 'pl-4 mb-2':'textbox-lable'}`} style={{paddingLeft:5}}>
                <Label for="position" className="field-lable">
                    Customer Type
                </Label>
            </div>
            <If condition={isMobile}>
                <div className="row text-size">
                    <div className={`${isMobile ? 'pl-4 mb-2':'textbox-lable'}`}>
                        <span style={{float:'right',marginTop:-13}} className="optional-text">(optional)</span>
                    </div>
                    <div className={`${isMobile && 'pl-4'} textbox-field `}>
                    </div>
                </div>
            </If>
            <div className={`${isMobile && 'pl-4'}  select-field`}>
                    <Select name="officeEndCustomer"
                        searchable={!isMobile}
                        placeholder={"Select the primary type of customer your office provides"}
                        options={customerTypes}
                        value={customerType}
                        onChange={this.handleOptionEndCustomer}
                        valueKey='_id'
                        labelKey='name'
                    />
            </div>
        </div>
        <If condition={!isMobile}>
            <div className="row text-size">
                <div className="textbox-lable">
                    <span style={{float:'right',marginTop:-13}} className="optional-text">(optional)</span>
                </div>
                <div className={`${isMobile && 'pl-4'} textbox-field `}>
                </div>
            </div>
        </If>
        {/* <div className="row text-size" style={{marginTop:20}}>
            <div className="textbox-lable">
                <Label for="size" className="field-lable">
                <span id="office-size-popover" style={{marginRight: '10px'}} onClick={this.toggleOfficeSizePopover}><Tooltip/></span>
                Size</Label>
                <Popover placement="left" isOpen={this.state.officeSizePopoverOpen} target="office-size-popover" toggle={this.toggleOfficeSizePopover}>
                 <PopoverHeader className="popover-header-tooltip">Office Size</PopoverHeader>
                 <PopoverBody className="popover-body-tooltip">Office size reflects number of employees in your office and is automatically calculated from the available employee data. To change it, you can upload new employee data.</PopoverBody>
               </Popover>
            </div>
            <div className="textbox-field">
                <Input type="text" className="input-custom" name="officeSize" style={{width:"60%"}} readOnly />
            </div>
        </div> */}
        <div className="row text-size" style={{marginTop:20}}>
            <div className={`${isMobile ? 'pl-4 mb-2':'textbox-lable'}`}>
                <Label for="location" className="field-lable">Location</Label>
            </div>
            <div className={`${isMobile && 'pl-4'} textbox-field `}>
            <PlacesAutocomplete
                onChange={this.handleAddressChange}
                value={this.state.address}
                onSelect={this.handleSelect}
                onError={this.handleError}
                shouldFetchSuggestions={this.state.address.length > 2}
                >
                {({ getInputProps, suggestions, getSuggestionItemProps }) => {
                    return (
                    <div>
                        <div className={"search-input-container"}>
                        <input
                            {...getInputProps({
                            placeholder: 'Start typing address of your office',
                            className: formErrorFields.indexOf('address') > -1 ? 'search-input-error' : 'search-input',
                            })}
                        />
                        </div>
                        {suggestions.length > 0 && (
                        <div className="autocomplete-container">
                            {suggestions.map(suggestion => {
                            const className = classnames('suggestion-item', {
                                'suggestion-item--active': suggestion.active,
                            });

                            return (
                                /* eslint-disable react/jsx-key */
                                <div
                                {...getSuggestionItemProps(suggestion, { className })}
                                >
                                <strong>
                                    {suggestion.formattedSuggestion.mainText}
                                </strong>{' '}
                                <small>
                                    {suggestion.formattedSuggestion.secondaryText}
                                </small>
                                </div>
                            );
                            /* eslint-enable react/jsx-key */
                            })}
                        </div>
                        )}
                    </div>
                    );
                }}
            </PlacesAutocomplete>
            {formError && (formErrorFields.indexOf('address') > -1) && <div className="input-error-msg-field">Please enter the main location of your office</div>}
        </div>
        </div>
        <div className="row mb10 mt50">
            <Col sm={{ size: "6" }}>
            <Row>
                <Col sm="6">
                <Button
                    className={`${isMobile && 'mb-4'} float-left goBackBtn w100`}
                    onClick={() => {this.props.history.push('/setup/personal-details')}}>
                    <span className="goBackBtnTxt">
                    <span className="ml10 flaticon-back"/> Go Back
                </span>
                </Button>
                </Col>
            </Row>
            </Col>
            <div className="col">
                <Button color="primary"
                  onClick={this.handleContinue}
                  className="btn-continue">
                  Continue<img style={{marginLeft:'10px'}} src={rightArrow} height="25px" width="25px" /></Button>
            </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => {
	return {
        user : state.user,
        office : state.office.details
	}
}

const mapDispatchToProps = dispatch => {
	return {
		onFetchOfficeSuccess : (data) => dispatch(actionCreators.fetchOfficeSuccess(data))
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(OfficeDetails);
